export default "__VITE_ASSET__C1YeM9Pb__"